import React from "react";
import { Collapse } from "antd";
import { map, isFunction } from "utils/lodash";
import cx from "classnames";

interface ExpandProps<T> {
  title: React.ReactNode | ((item: T) => React.ReactNode);
  defaultActiveKey?: string[];
  items: T[];
  className?: string;
  renderItem: (item: T) => React.ReactNode;
  alwaysExpanded?: boolean;
}

const Expand = <T extends { key?: string | number }>({
  title,
  defaultActiveKey = undefined,
  items,
  renderItem,
  className,
  alwaysExpanded = false,
}: ExpandProps<T>) => {
  const collapseItems = map(items, (item, index) => ({
    key: item.key || index,
    label: isFunction(title) ? title(item) : title,
    children: <React.Fragment key={index}>{renderItem(item)}</React.Fragment>,
  }));

  // If alwaysExpanded is true, set all panels as default expanded but still collapsible
  const allKeys = map(items, (item, index) => String(item.key || index));

  return (
    <Collapse
      className={cx("px-0", className)}
      items={collapseItems}
      ghost
      defaultActiveKey={alwaysExpanded ? allKeys : defaultActiveKey}
      expandIconPosition="end"
    />
  );
};

export default Expand;
